import React from 'react';
export function Footer() {
  return <footer className="bg-night px-3 py-3 text-center sm:px-6" data-id="element-63" data-mp="32wd2qgad7ltj">
      <p className="mx-auto max-w-2xl text-[0.62rem] leading-[1.45] text-white/60 sm:text-[0.72rem]" data-id="element-64" data-mp="3gfiu2hdxs9dl">
        © 2026 CARDIOLOGY VISUAL ATLAS™ — All Rights Reserved. CARDIOLOGY VISUAL ATLAS™ is an
        educational study and reference resource. It does not replace formal medical education,
        supervised clinical training, professional medical advice, diagnosis, treatment,
        institutional protocols or qualified clinical judgment.
      </p>
      <p className="mt-1 text-[0.62rem] text-white/70 sm:text-[0.72rem]" data-id="element-65" data-mp="36d3cxfoatnb">
        <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-66" data-mp="3ldu34pweqfur">
          Terms &amp; Conditions
        </a>{' '}
        •{' '}
        <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-67" data-mp="29yno3sf6hjhp">
          Privacy Policy
        </a>{' '}
        • Contact Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-68" data-mp="2ew734ujpa0ap">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}